import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { API_ENDPOINT, APP_CONFIG, ROUTER_CONFIG } from '@core/configs';
import {
  HttpClient,
  HttpHeaders,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { NEVER } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResourcePolicyService {

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
  ) {}

  checkResourcePolicy() {
    return this.http.get<any>(API_ENDPOINT.resourcepolicy.checkResourcePolicy, {
      headers: new HttpHeaders(
        {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'content-type': 'application/json',
          // eslint-disable-next-line quote-props
          'module': APP_CONFIG.module,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'x-requested-with': 'XMLHttpRequest',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'access-control-allow-origin': '*',
        },
      ),
      observe: 'response',
    }).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        if (Number(error.status) === HttpStatusCode.Forbidden || Number(error.status) === 0) {
          this.router.navigate([ROUTER_CONFIG.forbidden], { skipLocationChange: true });
        }
        return NEVER;
      }),
    );
  }

}
